import { useContext } from "react";
import { LanguageContext } from "../../../context/languageContext";

export default ({ id }) => {
  const { dictionary } = useContext(LanguageContext);
  return dictionary[id];
};
